import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

export default function EmailLinkTracker() {
  const { token } = useParams<{ token: string }>();
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const trackAndRedirect = async () => {
      if (!token) {
        setError('Token de rastreamento não encontrado');
        setIsLoading(false);
        return;
      }

      try {
        console.log('Tracking email link click with token:', token);

        const { data, error: functionError } = await supabase.functions.invoke('track-email-link', {
          body: { token }
        });

        if (functionError) {
          console.error('Error tracking click:', functionError);
          setError('Erro ao processar o link');
          setIsLoading(false);
          return;
        }

        if (data?.destination_url) {
          console.log('Redirecting to:', data.destination_url);
          // Add a small delay to ensure tracking is recorded
          setTimeout(() => {
            window.location.href = data.destination_url;
          }, 300);
        } else {
          setError('URL de destino não encontrada');
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Unexpected error:', error);
        setError('Erro inesperado ao processar o link');
        setIsLoading(false);
      }
    };

    trackAndRedirect();
  }, [token]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 text-primary animate-spin" />
      </div>
    );
  }

  return <div className="min-h-screen bg-background"></div>;
}